import { render, staticRenderFns } from "./AddSubAccount.vue?vue&type=template&id=00185124&"
import script from "./AddSubAccount.vue?vue&type=script&lang=ts&"
export * from "./AddSubAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports